import { render, staticRenderFns } from "./exercisesBoard.vue?vue&type=template&id=12ed5ae1&scoped=true&"
import script from "./exercisesBoard.vue?vue&type=script&lang=js&"
export * from "./exercisesBoard.vue?vue&type=script&lang=js&"
import style0 from "./exercisesBoard.vue?vue&type=style&index=0&id=12ed5ae1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ed5ae1",
  null
  
)

export default component.exports